<div class="backDrop center white" *ngIf="visibleSubject.asObservable() | async">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h3 class="modal-title text-center">{{this.title}}</h3>
			</div>
			<div class="modal-body">
				<div *ngIf="issues | async as issues">

					<table class="issue-table">
						<thead>
							<tr>
								<th>#</th>
								<th>Link ID</th>
								<th>Error Code</th>
								<th>Error Message</th>
								<th>Fix issue</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let issue of issues; let i = index">
								<td>{{ i + 1 }}</td>
								<td>{{ issue.linkId }}</td>
								<td>{{ issue.errorCode }}</td>
								<td>{{ issue.errorMessage }}</td>
								<td>TODO</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-danger" (click)="close()">
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
